export default "__VITE_ASSET__f4nBLXbp__"